import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-256">
      <button className="w-full py-4 px-2 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-257">
        <span className="font-bold text-gray-800 text-lg" data-id="element-258">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-259" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-260" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-261">
        <p className="text-gray-600 px-2" data-id="element-262">{answer}</p>
      </div>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Es material digital?',
    answer: 'Sí. Es 100% digital. Recibís acceso inmediato a la plataforma de descarga y podés acceder al material de por vida desde cualquier dispositivo.'
  }, {
    question: '¿Sirve para sesiones presenciales y online?',
    answer: 'Sí, absolutamente. Todas las técnicas y recursos están diseñados para adaptarse tanto al consultorio presencial como a la videollamada.'
  }, {
    question: '¿Es solo teoría?',
    answer: 'No. Es fundamentalmente práctico. Aunque incluye el marco clínico necesario, el foco está en la aplicación directa: qué hacer, cómo hacerlo y para qué.'
  }, {
    question: '¿Para quién no es?',
    answer: 'No es para personas que buscan acumular teoría académica sin intención de aplicarla. Es un sistema de acción clínica.'
  }];
  return <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-8" data-id="element-263">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-264" />)}
    </div>;
}